__turbopack_context__.v({
  "loading": "WistiaVideo-module-scss-module__7RZLTW__loading",
  "loadingIndicator": "WistiaVideo-module-scss-module__7RZLTW__loadingIndicator",
  "video": "WistiaVideo-module-scss-module__7RZLTW__video",
});
